export default function DiamondsMiddle() {
  return (
    <svg viewBox="0 0 1408 1408" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_233_61802"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="1408"
        height="1408"
      >
        <rect
          x="883.884"
          y="180.312"
          width="230"
          height="230"
          rx="20"
          transform="rotate(45 883.884 180.312)"
          strokeWidth="3px"
          stroke="#2CDDE9"
          fillOpacity="0"
        />
        <rect
          x="1064.2"
          y="360.625"
          width="230"
          height="230"
          rx="20"
          transform="rotate(45 1064.2 360.625)"
          strokeWidth="3px"
          stroke="#2CDDE9"
          fillOpacity="0"
        />
        <rect
          x="523.259"
          y="180.312"
          width="230"
          height="230"
          rx="20"
          transform="rotate(45 523.259 180.312)"
          strokeWidth="3px"
          stroke="#2CDDE9"
          fillOpacity="0"
        />
        <rect
          x="703.571"
          y="360.625"
          width="230"
          height="230"
          rx="20"
          transform="rotate(45 703.571 360.625)"
          strokeWidth="3px"
          stroke="#2CDDE9"
          fillOpacity="0"
        />
        <rect
          x="883.884"
          y="540.937"
          width="230"
          height="230"
          rx="20"
          transform="rotate(45 883.884 540.937)"
          strokeWidth="3px"
          stroke="#2CDDE9"
          fillOpacity="0"
        />
        <rect
          x="1064.2"
          y="721.249"
          width="230"
          height="230"
          rx="20"
          transform="rotate(45 1064.2 721.249)"
          strokeWidth="3px"
          stroke="#2CDDE9"
          fillOpacity="0"
        />
        <rect
          x="342.947"
          y="360.625"
          width="230"
          height="230"
          rx="20"
          transform="rotate(45 342.947 360.625)"
          strokeWidth="3px"
          stroke="#2CDDE9"
          fillOpacity="0"
        />
        <rect
          x="523.259"
          y="540.937"
          width="230"
          height="230"
          rx="20"
          transform="rotate(45 523.259 540.937)"
          strokeWidth="3px"
          stroke="#2CDDE9"
          fillOpacity="0"
        />
        <rect
          x="703.571"
          y="721.249"
          width="230"
          height="230"
          rx="20"
          transform="rotate(45 703.571 721.249)"
          strokeWidth="3px"
          stroke="#2CDDE9"
          fillOpacity="0"
        />
        <rect
          x="883.883"
          y="901.561"
          width="230"
          height="230"
          rx="20"
          transform="rotate(45 883.883 901.561)"
          strokeWidth="3px"
          stroke="#2CDDE9"
          fillOpacity="0"
        />
        <rect
          x="342.947"
          y="721.249"
          width="230"
          height="230"
          rx="20"
          transform="rotate(45 342.947 721.249)"
          strokeWidth="3px"
          stroke="#2CDDE9"
          fillOpacity="0"
        />
        <rect
          x="523.259"
          y="901.561"
          width="230"
          height="230"
          rx="20"
          transform="rotate(45 523.259 901.561)"
          strokeWidth="3px"
          stroke="#2CDDE9"
          fillOpacity="0"
        />
      </mask>
      <g mask="url(#mask0_233_61802)">
        <rect opacity="0.1" x="172" y="134" width="1110" height="1125" fill="#175DDC" />
      </g>
    </svg>
  )
}
